import { SupplierCompanyInfo } from 'components/buyer/supplierInfo/SupplierCompanyInfo';
import { SupplierContacts } from 'components/buyer/supplierInfo/SupplierContacts';
import { SupplierProfileCard } from 'components/buyer/supplierInfo/SupplierProfileCard';
import { SupplierStocks } from 'components/buyer/supplierInfo/SupplierStocks';
import { getSupplierCreditInfo } from 'components/buyer/supplierInfo/utilsSupplierInfo';
import { SellerCreditInfoModel } from 'models/buyer/suppliers/SellerCreditInfoModel';
import { SupplierCompanyModel } from 'models/buyer/suppliers/SupplierCompanyModel';
import { LoginResponseUserModel } from 'models/identity/LoginResponseUserModel';
import { useEffect, useState } from 'react';
import { useAuthUser } from 'react-auth-kit';
import { Card, Nav, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getUrlParams } from 'utils/getUrlParams';

export const SupplierInfo = () => {
  const [creditInfo, setCreditInfo] = useState<SellerCreditInfoModel>(
    {} as SellerCreditInfoModel
  );

  const [company, setCompany] = useState<SupplierCompanyModel>(
    {} as SupplierCompanyModel
  );

  const authUser = useAuthUser();
  const currentUser = authUser() as LoginResponseUserModel;

  const { t } = useTranslation('components');

  const supplierId = parseInt(getUrlParams('id') || '0');

  /* Get buyer's credit information */
  useEffect(() => {
    const getCreditInfo = async (): Promise<void> => {
      supplierId !== null &&
        (await getSupplierCreditInfo(setCreditInfo, currentUser, supplierId));
    };

    getCreditInfo();
  }, [currentUser, supplierId]);

  return (
    <div className='container-fluid p-2'>
      <Card className='p-1 settingsPage'>
        <Tab.Container
          id='supplierrCompanyInfo'
          defaultActiveKey='supplierCompanyInfo'
        >
          <div className='row flex-nowrap'>
            <div className='col col-side-menu-supplier-customer'>
              <div className='mb-4'>
                <SupplierProfileCard
                  company={company}
                  creditInfo={creditInfo}
                />
              </div>

              <Nav className='flex-column border p-0 mb-4 tabContainerSettings'>
                <Nav.Item className='border-bottom nav-item-hover'>
                  <Nav.Link eventKey='supplierCompanyInfo'>
                    {t('companySettings.hd_CompanyInformation')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className='border-bottom nav-item-hover'>
                  <Nav.Link eventKey='supplierStocks'>
                    {t('stockSettings.hd_Stocks')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className='nav-item-hover'>
                  <Nav.Link eventKey='supplierContacts'>
                    {t('common.hd_Contacts')}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <div className='col col-lg-10 '>
              <Tab.Content>
                <Tab.Pane eventKey='supplierCompanyInfo'>
                  <SupplierCompanyInfo
                    company={company}
                    setCompany={setCompany}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey='supplierStocks'>
                  <SupplierStocks />
                </Tab.Pane>
                <Tab.Pane eventKey='supplierContacts'>
                  <SupplierContacts supplierId={supplierId} />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </Card>
    </div>
  );
};
